import { render, staticRenderFns } from "./ResellersList.vue?vue&type=template&id=129370ae&scoped=true"
import script from "./ResellersList.vue?vue&type=script&lang=js"
export * from "./ResellersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129370ae",
  null
  
)

export default component.exports